module.exports = __webpack_public_path__ + "media/images/user/lp/step/ellipse1-4e6fbdb807eda2406855145f3fe2bbbb.png";